import { useUserManagementContext } from '../contexts/UserManagementContext';

const useUserManagement = () => {
    return useUserManagementContext();
}

export default useUserManagement
